import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";



export const fetchActiveOrgs = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}organization/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(org => ({ label: org.name, value: org.id }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};